module.exports = __webpack_public_path__ + "img/Tianjin-speed.0abd0332.png";